import { create } from 'zustand';

export type ConfirmVariant = 'danger' | 'warning' | 'info';

export interface ConfirmOptions {
  title: string;
  message?: string;
  detail?: string;
  variant?: ConfirmVariant;
  labelConfirm?: string;
  labelCancel?: string;
}

interface ConfirmStore {
  isOpen: boolean;
  options: ConfirmOptions | null;
  resolve: ((value: boolean) => void) | null;
  _open: (options: ConfirmOptions, resolve: (value: boolean) => void) => void;
  _close: () => void;
}

const useConfirmStore = create<ConfirmStore>((set) => ({
  isOpen: false,
  options: null,
  resolve: null,
  _open: (options, resolve) => set({ isOpen: true, options, resolve }),
  _close: () => set({ isOpen: false, options: null, resolve: null }),
}));

/**
 * Remplace window.confirm() par une boîte de dialogue professionnelle.
 *
 * Usage :
 *   const confirm = useConfirm();
 *   const ok = await confirm({ title: 'Supprimer ?', variant: 'danger' });
 *   if (!ok) return;
 */
export function useConfirm() {
  const { _open } = useConfirmStore();
  return (options: ConfirmOptions): Promise<boolean> =>
    new Promise((resolve) => _open(options, resolve));
}

export { useConfirmStore };
